import { useCallback, useMemo, useState } from 'react'
import { usePulseUiStore } from '@/features/pulsePanel/pulseUiStore'
import { ScheduleDetailsContext } from './scheduleDetailsContextValue.js'

/**
 * Which schedule the details panel is showing.
 *
 * Mounted above the secondary nav slot, not beside the router outlet like
 * `DocumentPreviewProvider` — the Scheduled rows that open this panel live in
 * the sidebar, which sits outside that provider's subtree.
 */
export function ScheduleDetailsProvider({ children }) {
  const [selectedScheduleId, setSelectedScheduleId] = useState(
    /** @type {string | null} */ (null),
  )
  const [selectedScheduleKind, setSelectedScheduleKind] = useState(
    /** @type {string | null} */ (null),
  )

  const openSchedule = useCallback((schedule) => {
    if (!schedule?.id) return
    // One right-hand panel at a time: a schedule replaces any open Pulse item.
    usePulseUiStore.getState().close()
    setSelectedScheduleId(String(schedule.id))
    setSelectedScheduleKind(String(schedule.objectType ?? 'workflow'))
  }, [])

  const closeSchedule = useCallback(() => {
    setSelectedScheduleId(null)
    setSelectedScheduleKind(null)
  }, [])

  const value = useMemo(
    () => ({
      selectedScheduleId,
      selectedScheduleKind,
      isOpen: selectedScheduleId != null,
      openSchedule,
      closeSchedule,
    }),
    [selectedScheduleId, selectedScheduleKind, openSchedule, closeSchedule],
  )

  return (
    <ScheduleDetailsContext.Provider value={value}>{children}</ScheduleDetailsContext.Provider>
  )
}
